"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    a11yText: 'Reveal additional information.'
  },
  fr: {
    a11yText: 'Afficher des renseignements supplémentaires.'
  }
};